export class RequestError extends Error {
  message: string;
  code: number;
  status: number;

  constructor({ message, code, status }: { message: string; code: number; status: number }) {
    super(message);
    this.message = message;
    this.code = code;
    this.status = status;
    Object.setPrototypeOf(this, RequestError.prototype);
  }
}

export interface ErrorResponse {
  error: {
    code: number;
    message: string;
  };
}

export const RequestMethod = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  PUT: 'PUT',
};
